var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAudioPauseBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69662",
    "data-name": "Group 69662",
    transform: "translate(21646.777 19146)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10508",
    "data-name": "Ellipse 10508",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(-21646.777 -19146)",
    fill: "#6b7992"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69661",
    "data-name": "Group 69661",
    transform: "translate(3.256 -40.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19219",
    "data-name": "Rectangle 19219",
    width: 5,
    height: 16,
    transform: "translate(-21638 -19093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19220",
    "data-name": "Rectangle 19220",
    width: 5,
    height: 16,
    transform: "translate(-21627.066 -19093)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioPauseBlue);
export default __webpack_public_path__ + "static/media/icon-audio-pause-blue.426bc013192325f408d11e68b53aea49.svg";
export { ForwardRef as ReactComponent };